export class Content {
    constructor({
        id,
        title,
        subtitle,
        description,
        contentType,
        thumbnailUrl,
        contentUrl,
        userRoles,
        additionalInfo,
        templateId,
        isBlocked,
        createdAt,
        updatedAt
    }) {
        this.id = id;
        this.title = title;
        this.subtitle = subtitle;
        this.description = description;
        this.contentType = contentType;
        this.thumbnailUrl = thumbnailUrl;
        this.contentUrl = contentUrl;
        this.userRoles = userRoles;
        this.additionalInfo = additionalInfo;
        this.templateId = templateId;
        this.isBlocked = isBlocked;
        this.createdAt = createdAt ? new Date(createdAt) : null;
        this.updatedAt = updatedAt ? new Date(updatedAt) : null;
    }

    static fromAPI(apiData) {
        return new Content({
            id: apiData.content_id,
            title: apiData.content_title,
            subtitle: apiData.content_subtitle,
            description: apiData.content_description,
            contentType: apiData.content_type,
            thumbnailUrl: apiData.content_thumbnail_url,
            contentUrl: apiData.content_url,
            userRoles: apiData.content_access,
            additionalInfo: apiData.content_additional_info,
            templateId: apiData.content_template_id,
            isBlocked: apiData.content_is_blocked,
            createdAt: apiData.content_created_at,
            updatedAt: apiData.content_updated_at
        });
    }

    toAPI() {
        return {
            content_id: this.id,
            content_title: this.title,
            content_subtitle: this.subtitle,
            content_description: this.description,
            content_type: this.contentType,
            content_thumbnail_url: this.thumbnailUrl,
            content_url: this.contentUrl,
            content_access: this.userRoles,
            content_additional_info: this.additionalInfo,
            content_template_id: this.templateId
        };
    }
} 